import { useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

export const useSwipe = (onLeft, onRight) => {
  const startX = useRef(null);
  return {
    onTouchStart: (e) => { startX.current = e.touches[0].clientX; },
    onTouchEnd: (e) => {
      if (startX.current === null) return;
      const dx = e.changedTouches[0].clientX - startX.current;
      startX.current = null;
      if (dx < -40) onLeft();
      else if (dx > 40) onRight();
    },
  };
};

export const PhotoLightbox = ({ images, index, onIndex, onClose, title }) => {
  const count = images.length;
  const step = (d) => onIndex((index + d + count) % count);
  const swipe = useSwipe(() => step(1), () => step(-1));

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") step(1);
      if (e.key === "ArrowLeft") step(-1);
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  });

  const navBtn = "absolute top-1/2 -translate-y-1/2 h-11 w-11 inline-flex items-center justify-center rounded-full bg-white/15 text-white hover:bg-white/30 transition-colors";
  return (
    <div className="fixed inset-0 z-[60] bg-black/95 flex flex-col" data-testid="photo-lightbox">
      <div className="flex items-center justify-between px-4 py-3 text-white">
        <span className="text-sm font-semibold truncate pr-4">{title}</span>
        <div className="flex items-center gap-3 shrink-0">
          <span className="text-xs text-white/70" data-testid="lightbox-counter">{index + 1} / {count}</span>
          <button onClick={onClose} aria-label="Close" className="h-9 w-9 inline-flex items-center justify-center rounded-full bg-white/15 hover:bg-white/30" data-testid="lightbox-close-btn"><X size={18} /></button>
        </div>
      </div>
      <div className="relative flex-1 min-h-0 flex items-center justify-center px-2 sm:px-16" {...swipe}>
        <img src={images[index]} alt={title} className="max-w-full max-h-full object-contain select-none" data-testid="lightbox-image" />
        {count > 1 && <>
          <button onClick={() => step(-1)} aria-label="Previous photo" className={`${navBtn} left-2 sm:left-4`} data-testid="lightbox-prev-btn"><ChevronLeft size={22} /></button>
          <button onClick={() => step(1)} aria-label="Next photo" className={`${navBtn} right-2 sm:right-4`} data-testid="lightbox-next-btn"><ChevronRight size={22} /></button>
        </>}
      </div>
      {count > 1 && (
        <div className="flex gap-2 overflow-x-auto no-scrollbar px-4 py-3 justify-start sm:justify-center">
          {images.map((im, i) => (
            <button key={i} onClick={() => onIndex(i)} className={`shrink-0 w-16 aspect-[4/3] rounded overflow-hidden border-2 ${i === index ? "border-white" : "border-transparent opacity-60"}`} data-testid={`lightbox-thumb-${i}`}>
              <img src={im} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
